import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    assets: 'Your personal wealth in €',
    fiscalId: 'NIF code',
    fiscalResidence: 'Your legal residence',
    income: 'Your annual income in €',
    no: 'No',
    otherFiscalResidence: 'Other legal residence',
    usCitizen:
      'Do you have US citizenship or pay taxes in the United States (US\u00A0person)?',
    yes: 'Yes',
  },
  fr: {
    assets: 'Votre patrimoine personnel en €',
    fiscalId: "Numéro d'identification fiscal",
    fiscalResidence: 'Votre domicile fiscal',
    income: 'Votre revenu annuel en €',
    no: 'Non',
    otherFiscalResidence: 'Autre domicile fiscal',
    usCitizen:
      'Avez-vous la citoyenneté américaine ou payez-vous des impôts aux États-Unis (US person)\u00A0?',
    yes: 'Oui',
  },
} as const);
